// stores/app/appStore.ts
import { defineStore } from 'pinia';
import { useSocketService } from '../../services/socketService';
import { Socket } from 'socket.io-client';

interface Message {
  id: number;
  text: string;
}

interface SocketState {
  socket: Socket | null;
  messages: Message[];
}

export const useAppStore = defineStore('appStore', {
  state: () => ({
    socket: null,
    onlineMasters: 0,
    totalMasters: 0,
    masters: [] as any[],
    calendarEvents: [] as any[],
    showLogin: false, // pro zobrazení login overlay
    currentEventType: null as string | null, // 👈 přidáno

    // match vars


    // ✨ NEW: Loading overlay
    showLoading: false,
    loadingMessage: '' as string | null,

    showPlayRequest: false, // pro zobrazení play request overlay
    needRefetch: false, // flag pro refetch dat
    dressColors: [
      'black-gold', 'black-red', 'blue-orange', 'blue-white',
      'gold-blue', 'grey-green', 'mh-blue', 'mh-white',
      'orange-blue', 'red-black', 'red-white', 'white-black',
      'white-blue', 'white-gold', 'white-green', 'white-red'
    ],
    eventData: [{
      kunda: 'kunda',
      event: 'event',
      date: '2023-10-10T12:00:00Z'
    }],
    // Nově přidáváme eventRecords do stavu
    eventRecords: [] as any[],
  }),

  actions: {


    setEventType(type?: string | null) {
      this.currentEventType = type ?? null;
    },
    clearEventType() {
      this.currentEventType = null;
    },



    triggerRefetch() {
      this.needRefetch = true;
    },

    clearRefetchFlag() {
      this.needRefetch = false;
    },

    connect() {
      this.socket = useSocketService();
      if (this.socket) {
        this.socket.on('masterData', (masters: any) => {
          this.masters = masters;
          this.totalMasters = masters.length;
          this.onlineMasters = masters.filter((master: any) => master.online).length;
        });
      }
    },

    disconnect() {
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
    },

    sendMessage(message: Message) {
      if (this.socket) {
        this.socket.emit('message', message);
      }
    },

    showLoginOverlay() {
      this.showLogin = true;
    },

    closeLoginOverlay() {
      this.showLogin = false;
    },

    showPlayRequestOverlay() {
      this.showPlayRequest = true;
    },

    closePlayRequest() {
      this.showPlayRequest = false;
    },



    // ✨ NEW: Loading overlay actions
    showLoadingOverlay(message?: string) {
      this.loadingMessage = message ?? null;
      this.showLoading = true;
    },
    closeLoadingOverlay() {
      this.showLoading = false;
      this.loadingMessage = null;
    },


    // Akce pro práci s eventRecords

    /**
     * Přidá nový záznam události do eventRecords
     */
    addEventRecord(record: any) {
      this.eventRecords.push(record);
      this.eventRecords.sort((a, b) => b.rawTime - a.rawTime);
    },

    /**
     * Odstraní záznam události podle jeho id
     */
    removeEventRecord(recordId: string) {
      this.eventRecords = this.eventRecords.filter(record => record.id !== recordId);
    }
  },

  getters: {
    isLoginVisible: (state) => state.showLogin,
    isPlayRequestVisible: (state) => state.showPlayRequest,
    // ✨ NEW
    isLoadingVisible: (s) => s.showLoading,
    eventType: (s) => s.currentEventType, // 👈 volitelný getter
  },
});
